import { withStyles, withTheme } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// ui/ux
import Autocomplete from '@material-ui/lab/Autocomplete';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

// ours
import Waiting from '../../../Waiting';
import { uuidv4 } from '../../../../common';

// GLOBALS
const API_HOST = process.env.REACT_APP_ADMIN_API_HOST;

const styles = (theme) => ({
  input: {
    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.palette.text.secondary
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.secondary
    }
  },
  selBox: {
    border: `1px dashed ${theme.palette.primary.main}`,
    minHeight: '234px',
    margin: `${theme.spacing(2)}px 0px ${theme.spacing(2)}px 0px`,
    padding: theme.spacing(2)
  },
  hintBox: {
    '& > h2': {
      lineHeight: '200px'
    },
    textAlign: 'center',
    color: theme.palette.primary.main
  }
});

class SelectTopics extends React.Component {
  constructor(props) {
    super(props);
    console.log('SelectTopics', JSON.stringify({ ...props, classes: null, theme: null, onComplete: null }));
    this.state = {
      id: uuidv4(),
      selectedTopics: [],
      topicACFieldText: ''
    };

    this.topicACFieldChanged = this.topicACFieldChanged.bind(this);
    this.topicACSelected = this.topicACSelected.bind(this);
    this.topicACOpened = this.topicACOpened.bind(this);
    this.topicACClosed = this.topicACClosed.bind(this);
    this.next = this.next.bind(this);

    this._xhrTopicsExisting = {};
  }
  componentDidMount() {
    // genericGet = async (url, token, callback, ignoreCredentials)
    this._xhrTopicsExisting.cancel && this._xhrTopicsExisting.cancel();
    window.genericGet(`${API_HOST}/admin/v0/topics/existing`, this._xhrTopicsExisting, (e, r) => {
      if (e) {
        return console.error(e);
      }

      this.setState({
        topics: r
      });
    });
  }

  componentDidUpdate() {}

  topicACFieldChanged(e) {
    const { value } = e.target;
    this.setState({
      topicACFieldText: value
    });
  }
  topicACSelected(_, v) {
    const { selectedTopics } = this.state;
    this.setState({
      topicACFieldText: '',
      selectedTopics: [...selectedTopics, v]
    });
  }

  topicACOpened() {}
  topicACClosed() {}
  next() {
    const { selectedTopics } = this.state;
    const { onComplete } = this.props;

    if (selectedTopics.length > 0) {
      onComplete(selectedTopics);
    }
  }
  renderButtons() {
    const { selectedTopics } = this.state;
    return (
      <Grid container justifyContent="flex-end" spacing={2}>
        <Grid item>
          <Button variant="outlined" color="secondary" onClick={this.next} disabled={selectedTopics.length === 0}>
            Next
          </Button>
        </Grid>
      </Grid>
    );
  }
  onClearTopic(d) {
    const { selectedTopics } = this.state;
    const i = selectedTopics.indexOf(d);
    this.setState({
      selectedTopics: [...selectedTopics.slice(0, i), ...selectedTopics.slice(i + 1)]
    });
  }
  render() {
    const { classes } = this.props;
    const { topics, id, topicACFieldText, selectedTopics } = this.state;
    if (!topics || topics.length === 0) {
      return <Waiting height="200" />;
    }
    const availableTopics = topics.filter((d) => selectedTopics.indexOf(d) === -1);
    return (
      <React.Fragment>
        <Typography variant="h5">Select topics relevant to this form -</Typography>
        {this.renderButtons()}
        <Box>
          <Autocomplete
            freeSolo
            value={null}
            onChange={this.topicACSelected}
            onOpen={this.topicACOpened}
            onClose={this.topicACClosed}
            inputValue={topicACFieldText}
            disableClearable
            id={`ac-topic-${id}`}
            options={availableTopics}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField {...params} onChange={this.topicACFieldChanged} placeholder="👩‍⚕️ Clinics" label="Add Topic" variant="outlined" fullWidth className={classes.input} />
            )}
          />
        </Box>
        <Box className={clsx(classes.selBox, selectedTopics.length === 0 && classes.hintBox)}>
          {selectedTopics.length > 0 ? (
            selectedTopics.map((d) => <Chip key={d} label={d} onClick={() => this.onClearTopic(d)} onDelete={() => this.onClearTopic(d)} color="primary" />)
          ) : (
            <Typography variant="h2">Selected Topics</Typography>
          )}
        </Box>
        {this.renderButtons()}
      </React.Fragment>
    );
  }
}

SelectTopics.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,

  onComplete: PropTypes.func.isRequired
};
SelectTopics.defaultProps = {};

export default withTheme(withStyles(styles)(SelectTopics));
